import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const StyledContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2),
    height: '50vh'
}));

const NotFoundMessage = ({ message }) => (
    <StyledContainer>
        <Typography variant="h6" color="textSecondary">
            {message}
        </Typography>
    </StyledContainer>
);

NotFoundMessage.propTypes = {
    message: PropTypes.string.isRequired
};

export default NotFoundMessage;
